// App PDF links are normal navigations, so they do not send the in-memory JWT and Rails bounces them to /login.
// Fetch with axios (auth interceptor adds the token) and show the file in a new tab.

export const shouldOpenAuthenticatedPdf = (rawUrl, origin) => {
  if (!rawUrl || !origin) return false;
  let parsed;
  try {
    parsed = new URL(rawUrl, origin);
  } catch (_e) {
    return false;
  }
  if (parsed.origin !== origin) return false;
  if (parsed.pathname.startsWith("/files/") || parsed.pathname.startsWith("/rails/")) return false;
  return /\.pdf$/i.test(parsed.pathname);
};

if (!shouldOpenAuthenticatedPdf("/project/1/technical_details/paint_systems.pdf", "https://lion.test")) {
  throw new Error("paint systems pdf");
}
if (shouldOpenAuthenticatedPdf("/project/1/technical_details/paint_systems", "https://lion.test")) {
  throw new Error("html path");
}
if (shouldOpenAuthenticatedPdf("https://other.test/file.pdf", "https://lion.test")) {
  throw new Error("external pdf");
}
if (shouldOpenAuthenticatedPdf("/files/Design Brief.pdf", "https://lion.test")) {
  throw new Error("static file");
}
if (!shouldOpenAuthenticatedPdf("welding_inspections/4.pdf?x=1", "https://lion.test")) {
  throw new Error("relative pdf");
}

export const openAuthenticatedPdf = (url, { method = "get", data } = {}) => {
  const tab = window.open("", "_blank");

  axios({ url, method, data, responseType: "blob" })
    .then((res) => {
      const blobUrl = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      if (tab) tab.location.href = blobUrl;
      else window.location.assign(blobUrl);
    })
    .catch(() => {
      if (tab) tab.close();
      if (window.toastr) window.toastr.error("Could not open this PDF.");
    });
};

const openFromForm = (form) => {
  const method = (form.getAttribute("method") || "get").toLowerCase();
  if (method === "post") {
    openAuthenticatedPdf(form.action, { method: "post", data: new FormData(form) });
    return;
  }
  const url = new URL(form.action, window.location.origin);
  new URLSearchParams(new FormData(form)).forEach((value, key) => url.searchParams.append(key, value));
  openAuthenticatedPdf(url.toString());
};

export const installPdfLinkInterceptor = () => {
  document.addEventListener(
    "click",
    (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const link = event.target.closest?.("a[href]");
      if (!link || !shouldOpenAuthenticatedPdf(link.href, window.location.origin)) return;
      event.preventDefault();
      event.stopPropagation();
      openAuthenticatedPdf(link.href);
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!form?.action || !shouldOpenAuthenticatedPdf(form.action, window.location.origin)) return;
      event.preventDefault();
      event.stopPropagation();
      openFromForm(form);
    },
    true
  );
};
